/*
 * Copyright (c) 2024.
 * The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 *
 */

import {useTypedSelector} from "helpers/reducers";

export const useHallOpening = () => {
    const hall = useTypedSelector(state => state.hallState.hall);
    const bookingFilter = useTypedSelector(state => state.bookingState.bookingProcess.filter);

    const hallOpeningDate: Date | undefined = hall ? new Date(hall.first_opening_date) : undefined;
    const hallOpeningDefined: boolean = !!hallOpeningDate;
    const hallAlreadyOpen: boolean = hall && hallOpeningDate ? new Date(bookingFilter.date).getTime() > hallOpeningDate?.getTime() : false;

    return {
        hallOpeningDate,
        hallOpeningDefined,
        hallAlreadyOpen,
    };
};
